import apiUrl from "./config/config";
import axios from "axios";

class languageApi {

  static async getLanguage()
  {

    try
    {

      const response = await axios(apiUrl + "language");

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

}

export default languageApi;
